import React, { Component } from "react"
import types from "prop-types"
import Formsy from "formsy-react"
import { copyFormToOrganizationPath } from "utils/routeHelpers"
import { copyFormSourceOrganizationShape, categoryOptionShape } from "utils/propTypeShapes"
import { TertiaryButton } from "shared/buttons"
import { OrganizationSelect } from "shared/selects"
import FieldLabel from "shared/FieldLabel"
import CopyFormToOrganizationFormFields from "./CopyFormToOrganizationFormFields"

const organizationWithId = (organizations, organizationId) => (
  organizations.find((organization) => organization.id === organizationId)
)

const organizationForms = (organizations, organizationId) => (
  organizationWithId(organizations, organizationId)?.forms
)

class CopyFormToOrganization extends Component {
  state = {
    canSubmit: false,
    sourceOrganizationId: this.props.copyFormSourceOrgs[0]?.id,
    selectedFormIds: [],
  }

  disableSubmit = () => this.setState({ canSubmit: false })

  enableSubmit = () => this.setState({ canSubmit: true })

  updateSelectedFormIds = (val) => this.setState({ selectedFormIds: val })

  disabled = () => !this.state.canSubmit || this.state.selectedFormIds.length === 0

  setSourceOrganizationId = (sourceOrganizationId) => this.setState({ sourceOrganizationId })

  render() {
    const { copyFormSourceOrgs, organizationSubdomain, targetCategories } = this.props
    const { sourceOrganizationId, selectedFormIds } = this.state
    const sortedOrgs = copyFormSourceOrgs.sort((a, b) => a.name.localeCompare(b.name))

    return (
      <Formsy
        action={copyFormToOrganizationPath(organizationSubdomain)}
        id="copy-form-to-organization-form"
        method="post"
        onInvalid={this.disableSubmit}
        onValid={this.enableSubmit}
        preventDefaultSubmit={false}
      >
        <FieldLabel text="Source organization">
          <OrganizationSelect
            backspaceDelete={false}
            onChange={this.setSourceOrganizationId}
            options={sortedOrgs}
            value={sourceOrganizationId}
          />
        </FieldLabel>
        <CopyFormToOrganizationFormFields
          sourceForms={organizationForms(copyFormSourceOrgs, sourceOrganizationId)}
          targetCategories={targetCategories}
          selectedFormIds={selectedFormIds}
          onChange={(val) => this.updateSelectedFormIds(val)}
        />
        <TertiaryButton
          form="copy-form-to-organization-form"
          text="Submit"
          type="submit"
          disabled={this.disabled()}
        />
      </Formsy>
    )
  }
}

CopyFormToOrganization.propTypes = {
  organizationSubdomain: types.string.isRequired,
  copyFormSourceOrgs: types.arrayOf(copyFormSourceOrganizationShape).isRequired,
  targetCategories: types.arrayOf(categoryOptionShape).isRequired,
}

export default CopyFormToOrganization
